import React from 'react';
import {
  Subtitle,
  TextSection,
  Title,
} from 'components/molecules/RecommendationsHeading/RecommendationsHeading.styled';

interface RecommendationsHeadingProps {
  title: string;
  subtitle?: string;
}

// Heading shared by the recommendation screens (upsell page, dead-link recovery).
const RecommendationsHeading = ({
  title,
  subtitle,
}: RecommendationsHeadingProps) => (
  <TextSection>
    <Title>{title}</Title>
    {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
  </TextSection>
);

export default RecommendationsHeading;
